import { Navigate, NavigateProps } from 'react-router-dom';
import { getUtmParams } from '@/lib/utils';

/**
 * Custom Navigate component that preserves UTM parameters on redirects
 * Use this instead of React Router's Navigate component for public-facing redirects
 */
export function UTMNavigate({ to, ...props }: NavigateProps) {
  const utmParams = getUtmParams();
  
  // Only add UTM parameters if they exist
  if (Object.keys(utmParams).length === 0) {
    return <Navigate to={to} {...props} />;
  }
  
  // Add UTM parameters to the destination
  if (typeof to === 'string') {
    // For string destinations
    const urlObj = new URL(to, window.location.origin);
    const searchParams = new URLSearchParams(urlObj.search);
    
    // Add UTM parameters to the URL, making sure to decode values to prevent double-encoding
    Object.entries(utmParams).forEach(([key, value]) => {
      searchParams.set(key, decodeURIComponent(value));
    });
    
    urlObj.search = searchParams.toString();
    return <Navigate to={urlObj.toString()} {...props} />;
  } else {
    // For object destinations
    const search = new URLSearchParams(to.search || '');
    
    // Add UTM parameters to the search params, making sure to decode values to prevent double-encoding
    Object.entries(utmParams).forEach(([key, value]) => {
      search.set(key, decodeURIComponent(value));
    });
    
    return <Navigate to={{ ...to, search: search.toString() }} {...props} />;
  }
}